import { Component, Input, AfterViewInit, Output, EventEmitter, ContentChild, OnChanges, SimpleChanges } from '@angular/core';
import { StringUtils } from '../../../utils/string.utils';
import { TabHeadingDirective } from '../tab-heading.directive';

@Component({
  selector: 'achoo-tab',
  templateUrl: './achoo-tab.component.html',
  styleUrls: ['./achoo-tab.component.scss']
})
export class AchooTabComponent implements AfterViewInit, OnChanges {
  @Input() textLabel: string;
  @Input() active: boolean;
  @Input() tabKey: string;
  @Input() isInfluencerTab = false;

  @Output() changed = new EventEmitter<any>();

  @ContentChild(TabHeadingDirective) tabHeading: TabHeadingDirective;

  ngAfterViewInit(): void {
    if (!this.tabKey || StringUtils.trim(this.tabKey) === '') {
      this.tabKey = StringUtils.uuid();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.changed.emit(this);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/achoo-tab/achoo-tab.component.ts